import { render } from "./PageLeaveDialog.vue?vue&type=template&id=0c831d80"
import script from "./PageLeaveDialog.vue?vue&type=script&lang=js"
export * from "./PageLeaveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__